


























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
import CardTabVue from "../CardTab.vue";
import IncomeReminderVue from "./IncomeReminder.vue";
import ScrollToBottomVue from "../../components/ScrollToBottom.vue";
import AccountingSystem from "@/data/AccountingSystem";
import ImportTaxVue from "./ImportTax.vue";
import "./china.js"; // 引入中国地图数据
import axios from "axios";
@Component({
	...mapGetters(["account"]),
	components: {
		"card-tab": CardTabVue,
		"income-reminder": IncomeReminderVue,
		"scroll-to-bottom": ScrollToBottomVue,
		"import-tax": ImportTaxVue,
	},
})
export default class AccountInfo extends Vue {
	@Prop({ type: Boolean, default: true })
	isEdit?: boolean;

	@Prop({ type: Boolean, default: false })
	isAccountVal?: boolean;

	@Prop({ type: Boolean, default: true })
	isChange?: boolean;

	@Prop({ type: Object })
	bookData?: AccountBookList.AccountBook;

	isJzs = process.env.VUE_APP_TITLE === "jzs";
	personalLoginWay: string = "申报密码登录";
	systemList = AccountingSystem;
	showTaxPwd: boolean = false;
	showPwd: boolean = false;
	showPersonalPwd: boolean = false;
	showRelPwd: boolean = false;
	showPayerPwd: boolean = false;
	accountingSystem: string = ""; //会计制度
	addtax: string = ""; //企业规模
	maxIncome: number | null = null; //最大收入
	stampTaxBasis: number = 0;
	tabs: InlineTab[] = [];
	activeTab: InlineTab = {
		id: 0,
		title: "账套信息",
	};
	payer: string = ""
	maxl: number = 11
	taxPayerList: InlineTab[] = [
		{
			id: 0,
			title: "法人",
		},
		{
			id: 1,
			title: "财务人员",
		},
		{
			id: 2,
			title: "办税员",
		},
		{
			id: 3,
			title: "领票人",
		},
		{
			id: 4,
			title: "其他人员",
		},
		{
			id: 5,
			title: "附办税人",
		},
	];
	loginWayList: InlineTab[] = [
		{
			id: 1,
			title: "旧版登录",
		},
		{
			id: 2,
			title: "新版登录",
		},
		{
			id: 3,
			title: "代理业务登录",
		},
		{
			id: 4,
			title: "新版登录验证",
		},
	];
	codeTip: string = "客户编码不能为空";
	taxData:any = {
		code: null,
		endDate: "",
		gmtCreate: null,
		gmtModified: null,
		id: null,
		isTaxInfo: 1,
		source: 2,
		startDate: "",
		taxInfoDetail: "",
		taxInfoMethod: 0,
		taxInfoType: "",
		taxRate: "",
	}
	isTaxList:any = [
		{
			id:1,
			text:"是"
		},
		{
			id:0,
			text:"否"
		},
	]
	taxType: string[] = [
	"增值税",
	"城市维护建设税",
	"教育费附加",
	"地方教育附加",
	"企业所得税",
	"印花税",
    "其他收入",
    "残疾人就业保障金",
    "文化事业建设费",
    "消费税",
    "水利建设专项收入",
    "个人所得税",
    "房产税",
    "行政性收费收入",
    "社保",
     "其他专项收入",
     "财务报表",
	 "城镇土地使用税"
	]
	importVisbile: boolean = false;

	// 判断是否为个人独资
	isOper(){
		if(this.accountBookInfo){
			if(this.comData.taxInfoMap["生产经营所得税"].id !==null){
				return true
			} else {
				if(this.accountBookInfo.companyType){
						if(this.accountBookInfo.companyType.includes("个人独资") || this.accountBookInfo.companyType.includes("有限合伙") || this.accountBookInfo.companyType.includes("普通合伙") || this.accountBookInfo.companyType.includes("个体工商户")){
							return true
						} else return  false
				}
			}
		}
	}

	// 国税信息变量
	loginWays: LoginWay[] = [
		{
			id: 0,
			name: "CA登录/U棒登录",
		},
		{
			id: 1,
			name: "网厅密码登录",
		},
	];
	chart: any = null;
	beforeDestroy() {
		if (!this.chart) {
			return;
		}
		this.chart.dispose();
		this.chart = null;
	}
	option: any = null;
	chinaConfigure() {
		this.option = {
			// 进行相关配置
			// backgroundColor: "#02AFDB",
			// tooltip: {}, // 鼠标移到图里面的浮动提示框
			dataRange: {
				show: false,
				min: 1,
				max: 3,
				text: ["High", "Low"],
				realtime: true,
				calculable: true,
				color: ["#ffb205", "#fedf9b", "#b3fab6"],
			},
			geo: {
				// 这个是重点配置区
				map: "china", // 表示中国地图
				roam: true,
				//  aspectScale: ,
				label: {
					normal: {
						show: true, // 是否显示对应地名
						textStyle: {
							color: "rgba(0,0,0,0.4)",
							fontSize: "8",
							fontWeight: "bolder",
						},
						align: "top",
						verticalAlign: "bottom",
					},
					distance: 150,
				},
				itemStyle: {
					normal: {
						borderColor: "rgba(0, 0, 0, 0.2)",
					},
					emphasis: {
						areaColor: null,
						shadowOffsetX: 0,
						shadowOffsetY: 0,
						shadowBlur: 20,
						borderWidth: 0,
						shadowColor: "rgba(0, 0, 0, 0.5)",
					},
				},
			},
			series: [
				{
					type: "scatter",
					coordinateSystem: "geo", // 对应上方配置
				},
				{
					type: "map",
					geoIndex: 0,
					data: [
						{
							name: "北京",
							value: 1,
						},
						{
							name: "上海",
							value: 1,
						},
						{
							name: "天津",
							value: 1,
						},
						{
							name: "广东",
							value: 1,
						},
						{
							name: "湖南",
							value: 1,
						},
						{
							name: "安徽",
							value: 1,
						},
						{
							name: "浙江",
							value: 1,
						},
						{
							name: "湖北",
							value: 1,
						},
						
						{
							name: "贵州",
							value: 1,
						},
						{
							name: "山东",
							value: 1,
						},
						{
							name: "河北",
							value: 1,
						},
						{
							name: "江苏",
							value: 1,
						},
						{
							name: "福建",
							value: 1,
						},
						{
							name: "江西",
							value: 1,
						},
						{
							name: "辽宁",
							value: 1
						},
						{
							name: "山西",
							value: 1
						},
						{
							name: "陕西",
							value: 1
						},
						{
							name: "云南",
							value: 1,
						},
						{
							name: "四川",
							value: 1,
						},
						{
							name: "大连",
							value: 1,
						},

						{
							name: "河南",
							value: 2,
						},
						{
							name: "重庆",
							value: 2,
						},
						{
							name: "广西",
							value: 2,
						},
						{
							name: "内蒙古",
							value: 2
						},
						
						{
							name: "宁夏",
							value: 2,
						},
						{
							name: "甘肃",
							value: 2,
						},
						{
							name: "西藏",
							value: 2,
						},
						{
							name: "新疆",
							value: 2,
						},
						{
							name: "黑龙江",
							value: 2,
						},
						{
							name: "海南",
							value: 2,
						},
						{
							name: "吉林",
							value: 2
						}
					],
				},
			],
		};
	}

	//地税信息变量
	businessType: string[] = [];
	bsType: string[] = ["货物及劳务", "服务、不动产和无形资产"];
	// 月份
	startPeriod: Date | String = "";
	pickerOptions0: any = {};
	// 选择会计
	accounterList: Account[] = [];
	accounterVal: Account | null | string = null;
	label: string | null = null;

	// account/accountBookInfo
	accountBookInfo: AccountBookList.Info = {
		address: null,
		businessPeriod: null,
		businessScope: null,
		businessStatus: null,
		businessType: 0,
		companyType: null,
		establishDate: null,
		landLoginWay: null,
		landPwd: "",
		personalLoginWay: "",
		personalPwd: "",
		legalPerson: null,
		nationalLoginWay: null,
		nationalPwd: "",
		nationalName: "",
		registeredCapital: null,
		registeredNo: null,
		socialCreditCode: null,
		taxPayerCode: "",
		taxPayerId: "",
		isVirtualAddress: false,
		isInventory: false,
		isMonthFinance: false,
		isMonthTax: false,
		realDeclareName: null,
		realDeclarePassword: null,
		taxPayerName: "",
		taxPayerPwd: "",
		irrigationWorks: null,
		unionFunds: null,
		taxPayerRole: "",
		taxPayerPhone: "",
		taxAuthorities:"",
		gsnbPhone:"",
		gsnbId:"",
		gsnbName: "",
		gsnbPassword:"",
		subOffice:"",
		departmentNo: "",
		loginWay:1,
		nationalNameNew:"",
		nationalPwdNew:"",
		taxPayerRoleNew:"",
		taxPayerPhoneNew:"",
		nationalNameAuth:"",
		socialCreditCodeAgent:"",
		nationalPwdAuth:"",
		taxPayerPhoneAuth:"",
		nationalNameAgent:"",
		nationalPwdAgent:"",
		taxPayerPhoneAgent:"",


	};
	// 手机短信
	showMessage: boolean = true;
	messageTime: string = "60s";
	phoneMessage: string = ""
	chargeMeail(name:string) {
		if (this.bookData) {
			if (this.bookData.accountBookInfo) {
				let tel = ""
				if(name === "gs") {
					if (this.bookData.accountBookInfo.gsnbPhone && this.accountBookInfo.gsnbPhone === this.bookData.accountBookInfo.gsnbPhone){
						tel = <string>(this.bookData.accountBookInfo.gsnbPhone)
					} else {
						this.$message({
						type: "warning",
						message: "请先保存手机号",
						});
					return
					}
				}
				if(name === "newPhone") {
					if (this.accountBookInfo.loginWay === 2) {
						if (this.bookData.accountBookInfo.taxPayerPhoneNew && this.accountBookInfo.taxPayerPhoneNew === this.bookData.accountBookInfo.taxPayerPhoneNew){
							tel = <string>(this.bookData.accountBookInfo.taxPayerPhoneNew)
						} else {
								this.$message({
								type: "warning",
								message: "请先保存手机号",
								});
							return

						}
					} else if (this.accountBookInfo.loginWay === 4) {
						if (this.bookData.accountBookInfo.taxPayerPhoneAuth && this.accountBookInfo.taxPayerPhoneAuth === this.bookData.accountBookInfo.taxPayerPhoneAuth){
							tel = <string>(this.bookData.accountBookInfo.taxPayerPhoneAuth)
						} else {
								this.$message({
								type: "warning",
								message: "请先保存手机号",
								});
							return

						}
					}
					else if (this.accountBookInfo.loginWay === 3) {
						if (this.bookData.accountBookInfo.taxPayerPhoneAgent && this.accountBookInfo.taxPayerPhoneAgent === this.bookData.accountBookInfo.taxPayerPhoneAgent){
							tel = <string>(this.bookData.accountBookInfo.taxPayerPhoneAgent)
						} else {
								this.$message({
								type: "warning",
								message: "请先保存手机号",
								});
							return

						}
					}

				}
				if(name === "phone") {
					if (this.bookData.accountBookInfo.taxPayerPhone && this.accountBookInfo.taxPayerPhone === this.bookData.accountBookInfo.taxPayerPhone){
						tel = <string>(this.bookData.accountBookInfo.taxPayerPhone)
					} else {
						this.$message({
						type: "warning",
						message: "请先保存手机号",
						});
					return
					}
				}
				Vue.axios
						.get(`http://fc.hongfund.com:8801/text/message/check?phone=${tel}`)
						.then((res) => {
							this.phoneMessage = res.data.message
						});
			}
		}
	}
	meail() {
		if (this.showMessage && this.bookData) {
			if (this.bookData.accountBookInfo) {
				if (this.bookData.accountBookInfo.taxPayerPhone && this.accountBookInfo.taxPayerPhone === this.bookData.accountBookInfo.taxPayerPhone) {
					axios.post("http://fc.hongfund.com:8801/text/message/send", {
						phone: this.bookData.accountBookInfo.taxPayerPhone
 					 })
 					 .then((response)=> {
 					   
 					 })
 					 .catch((error)=> {
 					   
 					 });
					this.showMessage = false
					let time = 60;
					let i = setInterval(() => {
						time--;
						if (time > 0) {
							this.messageTime = time + "s"
						} else {
							// 倒计时结束后
							clearInterval(i);
							this.showMessage = true,
								this.messageTime = "60s"
						}
					}, 1000);
				} else {
					this.$message({
						type: "warning",
						message: "请先保存办税人手机号",
					});
				}
			}
		}
	}
	showGsMessage: boolean = true;
	gsmessageTime: string = "60s";
	gsmeail() {
		if (this.showGsMessage && this.bookData) {
			if (this.bookData.accountBookInfo) {
				if (this.bookData.accountBookInfo.gsnbPhone && this.accountBookInfo.gsnbPhone === this.bookData.accountBookInfo.gsnbPhone) {
					axios.post("http://fc.hongfund.com:8801/text/message/send", {
						phone: this.bookData.accountBookInfo.gsnbPhone
 					 })
 					 .then((response)=> {
 					   
 					 })
 					 .catch((error)=> {
 					   
 					 });	
					this.showGsMessage = false
					let time = 60;
					let i = setInterval(() => {
						time--;
						if (time > 0) {
							this.gsmessageTime = time + "s"
						} else {
							// 倒计时结束后
							clearInterval(i);
							this.showGsMessage = true,
								this.gsmessageTime = "60s"
						}
					}, 1000);
				} else {
					this.$message({
						type: "warning",
						message: "请先保存工商联络员手机号",
					});
				}
			}
		}
	}
	showNewMessage: boolean = true;
	newmessageTime: string = "60s";
	newmeail(name:any) {
		if (this.showNewMessage && this.bookData) {
			if (this.bookData.accountBookInfo) {
				// @ts-ignore
				if (this.bookData.accountBookInfo[name] && this.accountBookInfo[name] === this.bookData.accountBookInfo[name]) {
					axios.post("http://fc.hongfund.com:8801/text/message/send", {
						// @ts-ignore
						phone: this.bookData.accountBookInfo[name]
 					 })
 					 .then((response)=> {				   
 					 })
 					 .catch((error)=> {
 					 });
					this.showNewMessage = false
					let time = 60;
					let i = setInterval(() => {
						time--;
						if (time > 0) {
							this.newmessageTime = time + "s"
						} else {
							// 倒计时结束后
							clearInterval(i);
							this.showNewMessage = true,
								this.newmessageTime = "60s"
						}
					}, 1000);
				} else {
					this.$message({
						type: "warning",
						message: "请先保存手机号",
					});
				}
			}
		}
	}
	// 建账月份弹窗
	showIncome: boolean = false;
	personalBankAccount: string = "";
	nationalBankAccount: string = "";

	created() {
		this.chinaConfigure();
		if (this.bookData && this.bookData.accountBookInfo) {

			this.stampTaxBasis = <number>(
				this.bookData.accountBookInfo.stampTaxBasis
			);
		}
		if (this.bookData && this.bookData.accountBookInfo) {
			this.personalBankAccount = <string>(
				this.bookData.accountBookInfo.personalBankAccount
			);
			this.nationalBankAccount = <string>(
				this.bookData.accountBookInfo.nationalBankAccount
			);
		}
		if (this.isEdit) {
			this.tabs = [
				{
					id: 0,
					title: "账套信息",
				},
				{
					id: 1,
					title: "登录信息",
				},
				{
					id: 2,
					title: "工商信息",
				},
				{
					id: 3,
					title: "申报税种",
				},
				{
					id: 4,
					title: "税务信息",
				},
			];

		} else {
			this.tabs = [
				{
					id: 0,
					title: "账套信息",
				},
			];
		}
	}
	async mounted() {
		await this.getAccounterList();
		if (this.isEdit) this.init();
		else {
			this.accounterVal = this.accounterList[0];
		}
	}

	// 判断列表中是否有当前账套的会计，若没有则向其中添加一个
	includeAccounter(accounter: Account) {
		for (let i = 0; i < this.accounterList.length; i++) {
			if (this.accounterList[i].no === accounter.no) return true;
		}
		return false;
	}

	transNum(num: number | null) {
		if (num === 1) return true;
		else return false;
	}

	init() {
		if (this.bookData) {
			let bookInfo = <AccountBookList.Info>this.bookData.accountBookInfo;
			if (
				this.bookData.partyName === null ||
				this.bookData.partyName === undefined
			)
				this.bookData.partyName = "";
			Object.keys(bookInfo).forEach((attr) => {
				if (
					attr != "isVirtualAddress" &&
					attr != "isMonthTax" &&
					attr != "isMonthFinance" &&
					attr != "isInventory"
				) {
					// @ts-ignore
					this.accountBookInfo[attr] = bookInfo[attr];
				}
			});
			if (this.bookData.accountBookInfo) {
				this.stampTaxBasis = <number>(
					this.bookData.accountBookInfo.stampTaxBasis
				);
			}
			this.bookName = this.bookData.bookName;
			this.bookCode = this.bookData.bookCode;
			this.accounterVal = {
				name: this.bookData.name,
				no: this.bookData.accounterNo,
				id: "",
				displayName: "",
				rpDisplayName: "",
				loginId: "",
			};

			if (!this.includeAccounter(this.accounterVal))
				this.accounterList.push(this.accounterVal);
			this.startPeriod =
				this.bookData.startPeriod.substring(0, 4) +
				"-" +
				this.bookData.startPeriod.substring(4, 6);
			this.accountingSystem = this.bookData.accountingSystem;
			this.addtax = this.bookData.addtax;
			this.maxIncome = this.bookData.maxIncome;
			this.customerStatus = this.bookData.hidden === "n" ? true : false;
			this.label = this.bookData.label;
			this.isReview = this.$utils.transNum(this.bookData.isReview);
			this.accountBookInfo.isVirtualAddress = this.$utils.transNum(
				<number>bookInfo.isVirtualAddress
			);
			this.accountBookInfo.isInventory = this.$utils.transNum(
				<number>bookInfo.isInventory
			);
			this.accountBookInfo.isMonthTax = this.$utils.transNum(
				<number>bookInfo.isMonthTax
			);
			this.accountBookInfo.isMonthFinance = this.$utils.transNum(
				<number>bookInfo.isMonthFinance
			);
			this.accountBookInfo.irrigationWorks = this.transNum(
				<number>bookInfo.irrigationWorks
			);
			this.accountBookInfo.unionFunds = this.transNum(
				<number>bookInfo.unionFunds
			);

			let bsType = <number>bookInfo.businessType;
			switch (bsType) {
				case 1: {
					this.businessType = [this.bsType[0]];
					break;
				}
				case 2: {
					this.businessType = [this.bsType[1]];
					break;
				}
				case 3: {
					this.businessType = this.bsType;
					break;
				}
				default: {
					this.businessType = [];
				}
			}
		}
	}
	// 客户姓名
	showNameTip: boolean = false;
	bookName: string = "";
	// 客户姓名焦点
	nameBlur() {
		if (this.bookName == "") {
			this.showNameTip = true;
		} else {
			this.showNameTip = false;
		}
	}

	bookCode: string = "";
	showCodeTip: boolean = false;
	// 输入框失去焦点
	codeBlur() {
		if (this.bookCode === "") {
			this.showCodeTip = true;
		} else {
			this.showCodeTip = false;
		}
	}
	changpayer() {

	}

	// 社会信用代码
	showCreditTip: boolean = false;
	creditBlur() {
		if (this.accountBookInfo.socialCreditCode == "") {
			this.showCreditTip = true;
		} else {
			this.showCreditTip = false;
		}
	}

	changeSystem(val: string) {
		if (this.accountingSystem === AccountingSystem.npo) {
			this.maxIncome = null;
		}
	}
	changeCompanySize(val: string) {
		if (val !== "小规模纳税人") {
			this.maxIncome = null;
		}
	}

	//启用凭证审核
	isReview: boolean = false;

	// 客户状态
	customerStatus: boolean = false; //客户状态

	//获取会计的信息
	page: number = 0;
	size: number = 15;
	totalPages: number = 0;
	getAccounterList() {
		return new Promise((resolve) => {
			Vue.axios
				.post(`accounts/find?page=${this.page}&size=${this.size}`, {
					query: this.acounterQuery,
					accounterNo: this.$store.state.account.no,
					accounterId: this.$store.state.account.id,
				})
				.then((res) => {
					for (let i = 0; i < res.data.content.length; i++) {
						this.accounterList.push(res.data.content[i]);
					}
					this.totalPages = res.data.totalPages;
					resolve("");
				});
		});
	}
	// 聚焦获取会计
	focusList() {
		this.accounterList = [];
		this.page = 0;
		return new Promise((resolve) => {
			Vue.axios
				.post(`accounts/find?page=${this.page}&size=${this.size}`, {
					query: this.acounterQuery,
					accounterNo: this.$store.state.account.no,
					accounterId: this.$store.state.account.id,
				})
				.then((res) => {
					for (let i = 0; i < res.data.content.length; i++) {
						this.accounterList.push(res.data.content[i]);
					}
					this.totalPages = res.data.totalPages;
					resolve("");
				});
		});
	}

	acounterQuery: string = "";
	remoteMethod(query: string) {
		this.acounterQuery = query;
		this.page = 0;
		this.accounterList = [];
		if (query == "") {
			this.accounterVal = null;
			this.page = 0;
		}
		this.getAccounterList();
	}
	bulrAccounter() {
		this.acounterQuery = "";
	}
	// 确定保存
	dataCopy: any = null;
	async save() {
		if (this.activeTab.id === 3 && this.bookData) {
			this.dataCopy = JSON.parse(JSON.stringify(this.comData));
			this.dataCopy.isVat = this.dataCopy.isVat ? 1 : 0;
			this.dataCopy.isVatMonth = this.dataCopy.isVatMonth ? 1 : 0;
			this.dataCopy.isSurtax = this.dataCopy.isSurtax ? 1 : 0;
			this.dataCopy.isStamp = this.dataCopy.isStamp ? 1 : 0;
			// this.dataCopy.isStampMonth = this.dataCopy.isStampMonth ? 1 : 0;
			this.dataCopy.stampBasis = this.dataCopy.stampBasis;
			this.dataCopy.isFinance = this.dataCopy.isFinance ? 1 : 0;
			this.dataCopy.isFinanceMonth = this.dataCopy.isFinanceMonth ? 1 : 0;
			this.dataCopy.isIncomeOperatingMonth = this.dataCopy.isIncomeOperatingMonth ? 1 : 0;
			this.dataCopy.isIncome = this.dataCopy.isIncome ? 1 : 0;
			this.dataCopy.isIncomeOperating = this.dataCopy.isIncomeOperating ? 1 : 0;
			this.dataCopy.isExcise = this.dataCopy.isExcise ? 1 : 0;
			this.dataCopy.isWater = this.dataCopy.isWater ? 1 : 0;
			this.dataCopy.isWaterZero = this.dataCopy.isWaterZero;
			this.dataCopy.isUnion = this.dataCopy.isUnion ? 1 : 0;
			this.dataCopy.isUnionZero = this.dataCopy.isUnionZero;
			this.dataCopy.isCulture = this.dataCopy.isCulture ? 1 : 0;
			this.dataCopy.isCultureZero = this.dataCopy.isCultureZero;
			this.dataCopy.isDisabled = this.dataCopy.isDisabled ? 1 : 0;
			this.dataCopy.isDisabledMonth = this.dataCopy.isDisabledMonth ? 1 : 0;
			this.dataCopy.isSocialSecurity = this.dataCopy.isSocialSecurity ? 1 : 0;
			Vue.axios
				.post(`taxform`, this.dataCopy)
				.then((res) => {
					this.$emit("success", res.data);
					return;
				});
		}
		let notNull: boolean = false;
		notNull = this.$utils.notNull([
			this.bookName,
			this.accountBookInfo.socialCreditCode,
			this.accountingSystem,
			this.addtax,
			this.accounterVal,
			this.startPeriod,
			// this.bookCode
		]);
		if (this.accountingSystem === AccountingSystem.npo) {
			notNull = this.$utils.notNull([
				this.bookName,
				this.accountBookInfo.socialCreditCode,
				<string>this.startPeriod,
				this.accounterVal,
				// this.bookCode
			]);
			this.maxIncome = null;
			this.addtax = "";
		}
		if (this.isEdit) {
			if (this.accountingSystem != AccountingSystem.npo) {
				notNull = this.$utils.notNull([
					this.bookName,
					this.accountingSystem,
					this.addtax,
					this.accounterVal,
					// this.bookCode
				]);
			} else {
				notNull = this.$utils.notNull([
					this.bookName,
					this.accountingSystem,
					this.accounterVal,
					// this.bookCode
				]);
			}
		}

		if (!notNull) {
			this.$message.warning("请填写全部信息");
			return;
		}

		let url: string,
			obj: any = {
				accounterNo: (<Account>this.accounterVal).no,
				name: (<Account>this.accounterVal).name,
				accountingSystem: this.accountingSystem,
				addtax: this.addtax,
				bookCode: this.bookCode,
				bookName: this.bookName,
				startPeriod: this.$utils.simpleDateFormat(
					new Date(<Date>this.startPeriod),
					"m",
					true
				),
				maxIncome: this.maxIncome,
				accountBookInfo: JSON.parse(
					JSON.stringify(this.accountBookInfo)
				),
				label: this.label
			};

		let book = <AccountBookList.AccountBook>this.bookData;
		if (!this.isEdit) {
			url = "accountbooks/create";
		} else {
			url = "accountbooks/modify";
			obj.id = book.id;
		}
		if (obj.accountBookInfo.loginWay === 4) obj.accountBookInfo.loginWay = 2


		obj.accountBookInfo.isVirtualAddress = this.accountBookInfo
			.isVirtualAddress
			? 1
			: 0;
		obj.accountBookInfo.isInventory = this.accountBookInfo
			.isInventory
			? 1
			: 0;
		obj.accountBookInfo.isMonthFinance = this.accountBookInfo.isMonthFinance
			? 1
			: 0;
		obj.accountBookInfo.irrigationWorks = this.accountBookInfo
			.irrigationWorks
			? 1
			: 0;
		obj.accountBookInfo.unionFunds = this.accountBookInfo.unionFunds
			? 1
			: 0;
		obj.accountBookInfo.isMonthTax = this.accountBookInfo.isMonthTax
			? 1
			: 0;
		obj.hidden = this.customerStatus ? "n" : "f";
		obj.isReview = this.isReview ? 1 : 0;
		obj.accountBookInfo.stampTaxBasis = this.stampTaxBasis;
		delete obj.socialCreditCode;
		let type = 0;
		if (this.businessType.length === 2) type = 3;
		else if (this.businessType[0] === this.bsType[1]) type = 2;
		else if (this.businessType.length === 0) type = 0;
		else type = 1;
		obj.accountBookInfo.businessType = type;
		obj.accountBookInfo.socialCreditCode = this.accountBookInfo.socialCreditCode;
		obj.accountBookInfo.taxPayerCode = this.accountBookInfo.socialCreditCode;

		obj.accountBookInfo.personalBankAccount = this.personalBankAccount;
		obj.accountBookInfo.nationalBankAccount = this.nationalBankAccount;

		Vue.axios.post(url, obj).then((res) => {
			this.$emit("success", res.data);
		});
	}
	// 关闭弹窗
	close() {
		this.$emit("close");
	}

	// 建账月份弹窗
	// 判断打开最大收入
	incomeDilog() {
		if (this.maxIncome != null) {
			this.showIncome = true;
		} else {
			this.$message({
				type: "warning",
				message: "账套未设置最大收入，请设置后再录入历史收入",
			});
		}
	}
	closeReminder() {
		this.showIncome = false;
	}
	reminderSuccess() {
		this.showIncome = false;
	}
	getName() {
		if (this.bookData) {
			if (this.bookData.partyName) {
				return "合作商：" + this.bookData.partyName;
			} else return "";
		}
	}
	isVat: boolean = false;
	isVatMonth: boolean = false;
	isSurtax: boolean = false;
	isStamp: boolean = false;
	isStampMonth = 0;
	stampBasis: boolean = false;
	isFinance: boolean = false;
	isFinanceMonth: boolean = false;
	isIncome: boolean = false;
	isExcise: boolean = false;
	isWater: boolean = false;
	isWaterZero: boolean = false;
	isUnion: boolean = false;
	isUnionZero: boolean = false;
	isCulture: boolean = false;
	isCultureZero: boolean = false;
	isDisabled: boolean = false;
	isDisabledMonth: boolean = false;
	comData: any = {};
	showName: string = ""
	changeTab(val: any) {
		this.showName = ""
		if (val.title === "申报税种" && this.bookData) {
			Vue.axios
				.get(`taxform?accountBookId=${this.bookData.id}`)
				.then((res) => {
					this.comData = res.data;
					this.comData.isVat = res.data.isVat === 1 ? true : false;
					this.comData.isVatMonth =
						res.data.isVatMonth === 1 ? true : false;
					this.comData.isSurtax =
						res.data.isSurtax === 1 ? true : false;
					this.comData.isStamp =
						res.data.isStamp === 1 ? true : false;
					this.comData.stampBasis = res.data.stampBasis;
					this.comData.isFinance =
						res.data.isFinance === 1 ? true : false;
					this.comData.isFinanceMonth =
						res.data.isFinanceMonth === 1 ? true : false;
					this.comData.isIncomeOperatingMonth =
						res.data.isIncomeOperatingMonth === 1 ? true : false;
					this.comData.isIncome =
						res.data.isIncome === 1 ? true : false;
					this.comData.isIncomeOperating =
						res.data.isIncomeOperating === 1 ? true : false;
					this.comData.isExcise =
						res.data.isExcise === 1 ? true : false;
					this.comData.isWater =
						res.data.isWater === 1 ? true : false;
					this.comData.isWaterZero = res.data.isWaterZero;
					this.comData.isUnion =
						res.data.isUnion === 1 ? true : false;
					this.comData.isUnionZero = res.data.isUnionZero;
					this.comData.isCulture =
						res.data.isCulture === 1 ? true : false;
					this.comData.isCultureZero = res.data.isCultureZero;
					this.comData.isDisabled =
						res.data.isDisabled === 1 ? true : false;
					this.comData.isDisabledMonth =
						res.data.isDisabledMonth === 1 ? true : false;
					this.comData.isSocialSecurity =
						res.data.isSocialSecurity === 1 ? true : false;	
					this.showName = val.title	
				});
		} else if (val.title === "税务信息") {
			this.getTaxData()

		}
	}

	taxInfoMethod = [
		{
			id:0,
			text:"季"
		},
		{
			id:1,
			text:"月"
		},
		{
			id:2,
			text:"次"
		},
		{
			id:3,
			text:"半年"
		},
		{
			id:4,
			text:"年"
		},
	]
	isShowTax: boolean = false

	geMethod(val:number){
		for(let i = 0; i<this.taxInfoMethod.length; i++){
			if(this.taxInfoMethod[i].id === val){
				return this.taxInfoMethod[i].text
			}
		}
	}

	taxInfoList:any = [];

	getTaxData(){
		if(this.bookData){
			Vue.axios
			.get(`tax/info/list?accountBookId=${this.bookData.id}`)
			.then((res) => {
				this.taxInfoList = res.data
			});

		}

	}
	delTax(item:any){
		this.$confirm(`确定删除吗？删除之后不可恢复，可能会影响当前或后期报税！`, "温馨提示").then(
            (action: any) => {
                if (action === "confirm") {
					Vue.axios
						.post(`tax/info/delete`,item)
						.then((res) => {
							this.getTaxData()
					});
                }
            }
        );

	}
	changeTax(item:any){
		this.isShowTax = true
		let obj = JSON.stringify(item)
		this.taxData = JSON.parse(obj)
	}
	addTaxInfo(){
		if(this.bookData){
		    this.isShowTax = true
			this.taxData = {
				code: null,
				endDate: "",
				gmtCreate: null,
				gmtModified: null,
				id: null,
				isTaxInfo: 1,
				source: 2,
				startDate: "",
				taxInfoDetail: "",
				taxInfoMethod: 0,
				taxInfoType: "",
				taxRate: "",
				accountBookId:this.bookData.id,
			}
		}
	}
	saveTaxInfo(){
		let list = this.taxData
		list.startDate = list.startDate !=""?this.$utils.simpleDateFormat(new Date(<Date>list.startDate),"d",true):""
		list.endDate = list.endDate !=""?this.$utils.simpleDateFormat(new Date(<Date>list.endDate),"d",true):""
	   
	   
	   	if(list.endDate !="" && list.startDate !=""  && list.taxInfoType !="") {
			Vue.axios
				.post(`tax/info/save`,this.taxData)
				.then((res) => {
						this.isShowTax = false
						this.getTaxData()
			});
		} else {
			this.$message.warning("请填写完整内容");
		}	



	}
	closeTax(){
		this.getTaxData()
		this.importVisbile = false
	}
	find(){
		this.getTaxData()
	}
    closeTaxInfo(){
		this.isShowTax = false
		this.getTaxData()
	}

	// 设置残疾人信息
	disableShow = false;
	clickSet() {
		this.disableShow = true;
	}
	confirmInfo() {
		this.disableShow = false;
	}
}
